import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["toast","isActive","error"] */ "/codebuild/output/src2126065393/src/stage-webapp/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["EventsInit"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/EventsInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsigWrapper"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/StatsigWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecialAccessProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/SpecialAccessProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/UserProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/src/utils/firebaseConfig.ts");
